var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.image),expression:"image"}],staticClass:"img-fluid lazyload img-day-size"})}
var staticRenderFns = []

export { render, staticRenderFns }